import { useEffect, useMemo, useState } from "react";
import { PageDS, Spacer, TabMenu, ToastContainerDS } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { DepartmentCards } from "./cards";
import { DepartmentBadges } from "./badges";

export const DepartmentCardsAndBadges = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [selectedTab, setSelectedTab] = useState<string>(params.tab ?? "cards");

  const tabs = useMemo(() => {
    return [
      {
        name: "cards",
        title: t("cards.tab.cards"),
      },
      {
        name: "badges",
        title: t("cards.tab.badges"),
      },
    ];
  }, [t]);

  useEffect(() => {
    if (selectedTab) {
      navigate(
        `/departments/cards/${selectedTab}${
          params.id !== undefined ? `/${params.id}` : ""
        }`,
      );
    }
  }, [navigate, params.id, selectedTab]);

  return (
    <PageDS
      title={t(`cards.tab.${selectedTab}`)}
      toaster={<ToastContainerDS />}
      topElement={
        <>
          <TabMenu
            tabs={tabs}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
          <Spacer y={0.5} />
        </>
      }
      supportButton={{
        showMail: true,
      }}
    >
      <DepartmentCards />
      <DepartmentBadges />
    </PageDS>
  );
};
